import type { WidgetDefinition } from "@nexus/widget-sdk";
import { manifest, Component, defaultConfig } from ".";
export const definition: WidgetDefinition = {
  id: manifest.id,
  module: { manifest, Component, defaultConfig },
  catalog: {
    description: manifest.description,
    domain: "ip-blocking",
    visual: "Ranked list",
    purposes: ["reporting"],
    audiences: ["analyst", "client"],
  },
  layout: { kind: "content" },
  defaultLayoutClassName: "col-span-12 lg:col-span-8",
};
